export interface ChangeRequest {
    id: number,
    description: string,
    justification: string,
    status: string,
    assignedto: string,
    dueDate: Date | null,
    dueInDays: number,
    priority: string,
    facility: string,
    requestor: string,
    submitDate: Date | null,
    build: boolean,
    closedDate: Date | null,
    createdDate: Date | null,
    mocDueDate: Date | null,
    ferrMoC: string,
    onBehalfOf: string
}

export class AcdFormAttachmentList {
    id: number | undefined | null;
    fileName: string | undefined;
    fileSize: string | undefined;
    blobURI: string | undefined;
}

export interface userData {
    id: number,
    isActive: boolean,
    name: string,
    email: string,
    adObjectId: string,
}

export interface Priority {
    id: number;
    label: string;
    order: number;
    isActive: boolean;
    numberofdays: number;
}

export interface Facility {
    id: number;
    label: string;
    order: number;
    isActive: boolean;
    reEntity: string;
    reEntityFilter: string;
    isre: boolean;
    branchcode: string;
    branchIdentifier: string;
}
export class FacilityAcd {
    id: number | null = null;
    label: string | null = null;
    order: number | null = null;
    isActive: boolean = false;
    reEntity: string | null = null;
    reEntityFilter: string | null = null;
    isre: boolean = false;
    branchcode: string | null = null;
    branchIdentifier: string | null = null;
}

export class userList {
    id: number | null = null;
    name: string | null = null;
    email: string | null = null;
}
export interface CreateACD {
    description: string,
    justification: string,
    assignedto: string,
    priority: number,
    facility: number,
    requestor: string,
    mocDueDate: string,
    ferrMoC: string,
    onBehalfOf: string
}
export interface UpdateAcd {
    description: string,
    justification: string,
    facility: number,
    mocDueDate: string,
    ferrMoC: string,
    onBehalfOf: string
}

export interface acdSummary {
    Label: string,
    CountOfAdd: number,
    CountOfChange: number,
    CountOfDelete: number,
    CountOfNoChange: number
}

export class UpdateAcdModel {
    description: string| undefined | null;
    justification: string| undefined| null;
    Facilityid: number| undefined;
    Mocduedate: Date | undefined | null | any;
    ferrMoC: string| undefined| null;
    onBehalfOf: number | undefined;
    FileAttachments: AttachmentDetails[] | undefined;
}

export class commentsHistoryModel {
    type: string | undefined;
    status: string | undefined;
    comment: string | undefined;
    submittedDateTime: Date | undefined;
    changedBy: string | undefined;
    changeRequestCommentId: number | undefined;
    filenametext: string | undefined;
}
export class FormDataModel {
    Description: string | undefined | null;
    Justification: string | undefined | null;
    Assignedto: string | undefined | null;
    Facilityid: number | undefined | null;
    Requestpriorityid: number | undefined | null;
    Createdby: string | undefined | null;
    Mocduedate: string | undefined | null;
    Ferrmoc: string | undefined | null;
    onBehalfOf: number | undefined | null;
    changerequeststatusid: number | undefined | null;
    domainid: number | undefined | null;
    fileAttachments: AttachmentDetails[] | undefined;
}

export class CommentDataModel {
    comment: string | undefined | null;
    changeRequestId: number | undefined | null;
    createdBy: string | undefined | null;
    changeRequestCommnetsTypeId: number | undefined | null;
    fileAttachments: AttachmentDetails[] | undefined;
}

export class EditCommentModel {
    comment: string | undefined | null;
    changeRequestId: number | undefined | null;
    changeRequestCommentId: number | undefined | null;
    fileAttachments: AttachmentDetails[] | undefined;
}

export class CloseCancelDataModel {
    comment: string | undefined | null;
    changeRequestId: number | undefined | null;
    createdBy: string | undefined | null;
    changeRequestCommnetsTypeId: number | undefined | null;
    fileAttachments: AttachmentDetails[] | undefined;
    statusId: number | undefined | null;
}

export class AttachmentDetails {
    id: number | undefined | null;
    operation: number = 0;
    attachmentTypeId: number | undefined;
    fileName: string | undefined;
    fileSize: string | undefined;
    fileType: string | undefined;
    blobURI: string | undefined;
    attachmentId: string | undefined;
}

export class EditAttachmentDetails {
    id: number | undefined | null;
    operation: number = 0;
    attachmentTypeId: number | undefined;
    filename: string | undefined;
    fileSize: string | undefined;
    fileType: string | undefined;
    blobURI: string | undefined;
}
export enum AttachmentOperation {
    None = 0,
    Create = 1,
    Update = 2,
    Delete = 3
}

export interface acdSummaryData {
    crno: number,
    RequestedBY: string,
    OnBehalfOf: string,
    Status: string,
    AssignedTo: string,
    Facility: string,
    Priority: string,
    CreatedDate: string,
    SubmissionDate: string,
    TargetDate: string
}


export interface mwoBuild {
    "isChanged": boolean,
    "acdAction": string,
    "mwoNumber": number,
    "equipTagNumber": number,
    "mwoShortDescription": string,
    "mwoProblemDescription": string,
    "jobPlanNumber": number,
    "areaOwnerCode": number,
    "assignedExecutionCoordinatorCode": string,
    "leadCraft": string,
    "woClassification": string,
    "primaryDiscipline": string,
    "integrityCriticalTask": string,
    "performanceStandard": string,
    "integrityCriticalRanking": string,
    "shutDownCode": string,
    "shutdownClassification": string,
    "validateFlag": string,
    "fileName": string,
    "urlFile": string,
    "description": string,
    "textAttachment": string
}

export class acdSummary {
    id: number | null = null;
    label: string | null = null;
    totalAdd: number | null = null;
    totalChange: number | null = null;
    totalDelete: number | null = null;
    totalNoChange: number | null = null;
}

export class UserList {
    id: number | null = null;
    name: string | null = null;
    email: string | null = null;
}

export class DDClass {
    id!: number;
    label!: string;
}
